import { TruckIcon } from "@heroicons/react/24/outline";
import React from "react";
import { Status } from "../../common/components/status";
import { classNames } from "../../common/utils/classnames";
import { LeafletDraftFragment } from "../../graphql/generated";

const LeafletDraftPic: React.FC<{
  leafletDraft?: LeafletDraftFragment;
  large?: boolean;
}> = ({ leafletDraft, large }) => {
  const status = React.useMemo(() => {
    return Status.for(leafletDraft);
  }, [leafletDraft]);

  return (
    <TruckIcon
      className={classNames(
        status.color.picClasses(),
        large ? "h-20 w-20" : "h-10 w-10",
        "rounded-full border-2"
      )}
    />
  );
};

export default LeafletDraftPic;
